export const winterPosts = [
  {
    id: 'winter-boiler-radiator-care',
    title: 'Keeping Your Boiler & Radiators Running Strong All Winter',
    excerpt: 'Many Twin Cities homes rely on hot water or steam heat. Here is how to keep your boiler and radiators working efficiently through the coldest months of the year.',
    content: `
      <p>Older homes across Saint Paul and Minneapolis often rely on boilers and radiators for steady, comfortable heat. These systems can last for decades, but they perform best when homeowners give them a little attention during the heating season.</p>

      <h2>Bleed Your Radiators</h2>
      <p>If the top of a radiator stays cool while the bottom is warm, air is likely trapped inside. Use a radiator key to slowly open the bleed valve until water starts to appear, then close it. Keep a towel handy to catch drips.</p>

      <h2>Watch the Pressure Gauge</h2>
      <p>Most residential hot water boilers operate between 12 and 15 PSI when cold and up to about 25 PSI when hot. Pressure that is consistently too low or too high is a sign that something needs attention.</p>

      <h2>Keep Radiators Clear</h2>
      <ul>
        <li>Move furniture and heavy drapes away from radiators</li>
        <li>Avoid covering radiators with shelves or decorative boxes that trap heat</li>
        <li>Dust radiator fins regularly so heat moves freely into the room</li>
      </ul>

      <h2>Listen for Changes</h2>
      <p>Banging, clanking or gurgling sounds can point to trapped air, low water levels or sediment. A sudden change in how your system sounds is worth a professional look.</p>

      <h2>Steam Boiler Owners</h2>
      <p>Check the sight glass regularly to confirm the water level is where it should be, and never add water to a hot, empty boiler. If the level keeps dropping, have the system inspected for leaks.</p>

      <p><strong>Boiler acting up?</strong> Bruce Nelson Plumbing & Heating has been servicing Twin Cities boilers since 1976. Call 651-738-9354 to schedule a visit.</p>
    `,
    image: 'https://images.pexels.com/photos/12644994/pexels-photo-12644994.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: 'October 20, 2026',
    readTime: '5 min read',
    category: 'Boilers',
    season: 'winter',
  },
  {
    id: 'lower-winter-heating-bill',
    title: '8 Ways to Lower Your Winter Heating Bill in Minnesota',
    excerpt: 'Minnesota winters are long, and heating costs add up fast. These practical steps help you stay comfortable while keeping more money in your pocket.',
    content: `
      <p>Heating is the single largest energy expense for most Minnesota households. The good news is that small, consistent habits can make a noticeable difference on your monthly bill.</p>

      <h2>1. Use a Programmable or Smart Thermostat</h2>
      <p>Lowering the temperature by 7 to 10 degrees while you sleep or are away can reduce heating costs significantly over the season.</p>

      <h2>2. Replace Furnace Filters</h2>
      <p>A clogged filter forces your system to work harder. Check it monthly during winter and replace it when it looks dirty.</p>

      <h2>3. Seal Drafts</h2>
      <p>Weatherstrip doors, caulk window gaps and add foam gaskets behind outlet covers on exterior walls.</p>

      <h2>4. Open Curtains on Sunny Days</h2>
      <p>Let the sun warm south-facing rooms during the day, then close curtains at night to hold the heat in.</p>

      <h2>5. Lower Your Water Heater Temperature</h2>
      <p>Setting your water heater to 120°F is comfortable for most families and reduces standby energy loss.</p>

      <h2>6. Keep Vents and Radiators Clear</h2>
      <p>Furniture, rugs and drapes that block vents or radiators keep warm air from circulating.</p>

      <h2>7. Use Ceiling Fans in Reverse</h2>
      <p>Running fans clockwise on low gently pushes warm air that collects near the ceiling back down into the room.</p>

      <h2>8. Schedule Routine Maintenance</h2>
      <p>A clean, well-adjusted heating system runs more efficiently and is less likely to break down during a cold snap.</p>

      <p><strong>Ready for a more efficient winter?</strong> Call Bruce Nelson Plumbing & Heating at 651-738-9354.</p>
    `,
    image: 'https://images.unsplash.com/photo-1539298781177-895e382e795c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    date: 'October 19, 2026',
    readTime: '6 min read',
    category: 'Heating',
    season: 'winter',
  },
  {
    id: 'dry-winter-air-humidity-tips',
    title: 'Beat Dry Winter Air: Home Humidity Tips for Comfort',
    excerpt: 'Static shocks, dry skin and cracked wood floors are all signs your home is too dry. Learn how to bring indoor humidity back into a comfortable range.',
    content: `
      <p>When cold outdoor air is heated indoors, its relative humidity drops sharply. In a Minnesota winter, indoor humidity can fall well below comfortable levels without you noticing until the static shocks start.</p>

      <h2>Signs Your Home Is Too Dry</h2>
      <ul>
        <li>Frequent static shocks</li>
        <li>Dry, itchy skin and chapped lips</li>
        <li>Gaps forming in hardwood floors or trim</li>
        <li>Houseplants that wilt quickly</li>
      </ul>

      <h2>What Is a Comfortable Range?</h2>
      <p>Many homes feel best between 30% and 40% relative humidity in winter. On the coldest days, aim toward the lower end of that range to help prevent condensation and frost on windows.</p>

      <h2>Portable vs. Whole-Home Humidifiers</h2>
      <p>Portable units work well for a single bedroom but need daily refilling and regular cleaning. A whole-home humidifier connects to your heating system and water supply, adding moisture evenly throughout the house with very little upkeep.</p>

      <h2>Simple Ways to Add Moisture</h2>
      <ul>
        <li>Air-dry laundry indoors</li>
        <li>Leave the bathroom door open after showers</li>
        <li>Add a few more houseplants</li>
      </ul>

      <h2>Don't Overdo It</h2>
      <p>Too much humidity can lead to window condensation and mold. An inexpensive hygrometer helps you keep an eye on indoor levels.</p>

      <p><strong>Thinking about a whole-home humidifier?</strong> Call Bruce Nelson Plumbing & Heating at 651-738-9354.</p>
    `,
    image: 'https://images.pexels.com/photos/18507871/pexels-photo-18507871.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: 'October 17, 2026',
    readTime: '5 min read',
    category: 'Heating',
    season: 'winter',
  },
  {
    id: 'frozen-pipe-safe-thawing-steps',
    title: 'My Pipes Froze. Now What? Safe Thawing Steps for Homeowners',
    excerpt: 'Turned on the faucet and nothing came out? Here is what to do, and what never to do, when a pipe freezes during a Minnesota cold snap.',
    content: `
      <p>Even well-prepared homes can end up with a frozen pipe when temperatures drop below zero for days at a time. Acting quickly and safely can keep a frozen pipe from turning into a burst pipe.</p>

      <h2>Step 1: Find the Frozen Section</h2>
      <p>Check pipes along exterior walls, in unheated basements, crawl spaces and garages. Frost on the pipe or a section that feels much colder than the rest is a good clue.</p>

      <h2>Step 2: Open the Faucet</h2>
      <p>Open the faucet the pipe feeds. As the ice melts, flowing water helps thaw the rest of the blockage and relieves pressure in the line.</p>

      <h2>Step 3: Apply Gentle Heat</h2>
      <ul>
        <li>Use a hair dryer, starting near the faucet and working back toward the frozen area</li>
        <li>Wrap the pipe with towels soaked in warm water</li>
        <li>Use a space heater nearby, kept at a safe distance from anything flammable</li>
      </ul>

      <h2>Never Do This</h2>
      <ul>
        <li>Never use an open flame, propane torch or charcoal stove</li>
        <li>Never leave a space heater running unattended</li>
      </ul>

      <h2>Know Where Your Main Shutoff Is</h2>
      <p>If a pipe has already cracked, shut off the main water valve right away to limit water damage, then call a licensed plumber.</p>

      <h2>Prevent It From Happening Again</h2>
      <p>Insulate exposed pipes, seal drafts near plumbing and keep cabinet doors open on the coldest nights.</p>

      <p><strong>Need help with a frozen or damaged pipe?</strong> Call Bruce Nelson Plumbing & Heating at 651-738-9354.</p>
    `,
    image: 'https://images.pexels.com/photos/4092030/pexels-photo-4092030.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: 'October 16, 2026',
    readTime: '5 min read',
    category: 'Plumbing',
    season: 'winter',
  },
];
